import styled from 'styled-components/macro';

import Button from '../Button';

export const DemographicsModalContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ModalGraphic = styled.img`
  @media (max-width: ${({ theme }) => theme.device.laptop}px) {
    display: none;
  }
  height: 179px;
  margin-right: 3rem;
`;

export const ModalContent = styled.div`
  overflow-y: auto;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.padding}px;
`;

export const Submit = styled(Button)`
  margin-top: 2rem;
  width: 100%;
  border: none;
  color: #658cd7;
  font-size: 1.2rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding-left: 4rem;
  padding-right: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background-image: linear-gradient(
    90deg,
    rgba(117, 219, 255, 0.4) 0%,
    rgba(169, 168, 255, 0.4) 100%
  );
`;
